export const HOST_MEETING_SUCCESS = 'HOST_MEETING_SUCCESS';
export const HOST_MEETING_FAILURE = 'HOST_MEETING_FAILURE';

export const JOIN_MEETING_SUCCESS = 'JOIN_MEETING_SUCCESS';
export const JOIN_MEETING_FAILURE = 'JOIN_MEETING_FAILURE';

export const SET_MEETING_PARTICIPANTS = 'SET_MEETING_PARTICIPANTS';

export const MEETING_CHAT_FETCH_SUCCESS = 'MEETING_CHAT_FETCH_SUCCESS';
export const MEETING_CHAT_FETCH_FAILURE = 'MEETING_CHAT_FETCH_FAILURE';

export const MEETING_VIDEO_CONFIG_OPTIONS = 'MEETING_VIDEO_CONFIG_OPTIONS';

export const MEETING_CHAT_MESSAGES = 'MEETING_CHAT_MESSAGES';

export const MEETING_LEAVE = 'MEETING_LEAVE';